/**
 * The channel's logotype mark.
 *
 * The same geometry as the card renderer's mark (`backend/src/rendering/core/
 * icons.tsx`), traced from the logotype artwork: a ring with a wedge open to
 * the right, and the dot and stem of the "i" in its counter. The C takes
 * `currentColor` so it reads on both admin themes; the dot keeps the brand red.
 */
export function BrandMark({ className = 'h-[15px] w-[15px]' }: { className?: string }) {
  return (
    <svg viewBox="0 0 620 620" className={className} fill="none" aria-hidden="true">
      <path
        d="M571.4 476.6 A310 310 0 1 1 571.4 143.4 L462.7 212.8 A181 181 0 1 0 462.7 407.2 Z"
        fill="currentColor"
      />
      <rect x="264" y="164" width="87" height="74" fill="#FD272A" />
      <rect x="264" y="261" width="87" height="210" fill="currentColor" />
    </svg>
  );
}
